import React from 'react';
import { AddIcon, RemoveIcon } from '@root/styles/icons';
import {
  PopperRow,
  PopperOptionLabelDescription,
  PopperOptionLabelWrapper,
  PopperOptionCountButtons,
  PopperOptionCounter,
} from '../Popper';
import { IconButton } from '../IconButton';
import { PlusIconButton } from './GuestPicker.styles';

type GuestCounterProps = {
  count: number;
  disabledMinus: boolean;
  disabledPlus: boolean;
  label: string;
  labelDescription?: string;
  onClickMinus: () => void;
  onClickPlus: () => void;
};

export function GuestCounter({
  count,
  disabledMinus,
  disabledPlus,
  label,
  labelDescription,
  onClickMinus,
  onClickPlus,
}: GuestCounterProps) {
  return (
    <PopperRow>
      <PopperOptionLabelWrapper>
        {label}
        {labelDescription && (
          <PopperOptionLabelDescription>{labelDescription}</PopperOptionLabelDescription>
        )}
      </PopperOptionLabelWrapper>
      <PopperOptionCountButtons>
        <IconButton
          type="button"
          onClick={onClickMinus}
          aria-label="-1"
          data-testid={`decrement-${label}`}
          disabled={disabledMinus}
        >
          <RemoveIcon />
        </IconButton>
        <PopperOptionCounter data-testid={`${label}-count`}>{count}</PopperOptionCounter>
        <PlusIconButton
          type="button"
          onClick={onClickPlus}
          data-testid={`increment-${label}`}
          disabled={disabledPlus}
          aria-label="+1"
        >
          <AddIcon />
        </PlusIconButton>
      </PopperOptionCountButtons>
    </PopperRow>
  );
}
